__turbopack_context__.v({
  "Caption": "ImageBlock-module-scss-module__ktYo3q__Caption",
  "HasReducedMobileHeight": "ImageBlock-module-scss-module__ktYo3q__HasReducedMobileHeight",
  "Image": "ImageBlock-module-scss-module__ktYo3q__Image",
  "ImageBlock": "ImageBlock-module-scss-module__ktYo3q__ImageBlock",
  "IsFullHeight": "ImageBlock-module-scss-module__ktYo3q__IsFullHeight",
  "IsSmall": "ImageBlock-module-scss-module__ktYo3q__IsSmall",
  "isFullWidth": "ImageBlock-module-scss-module__ktYo3q__isFullWidth",
});
